import React from 'react';
import { Stack, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { styles } from '../styles';
import { useQueryClient } from '@tanstack/react-query';
import { IIntegrationsResponse } from '../../types';
import formatToUserTimeZone from '../../../utils/formatToUserTimeZone';

export default function MvsRecord() {
  const queryClient = useQueryClient();
  const integrationsData = queryClient.getQueryData<IIntegrationsResponse>(['integrations']);
  return (
    <Stack sx={styles.integrationDetails}>
      <Stack sx={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
        <Stack sx={{ fontSize: '16px', fontWeight: 600 }}>MVS requested tests</Stack>
      </Stack>
      <Table sx={styles.integrationDetailsTable}>
        <TableHead>
          <TableRow>
            {['Package name', 'Checks', 'Status', 'Requested at'].map((title, index) => (
              <TableCell sx={styles.integrationDetailsTableHeader} key={index}>
                <Stack>{title}</Stack>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {integrationsData?.mvs_requests.map((request, index) => (
            <TableRow key={index}>
              <TableCell sx={{ verticalAlign: 'top' }}>{request.package_name}</TableCell>
              <TableCell sx={{ verticalAlign: 'top' }}>
                {request.blueprint_ids.join(', ')}
              </TableCell>
              <TableCell sx={{ verticalAlign: 'top' }}>{request.status}</TableCell>
              <TableCell sx={{ verticalAlign: 'top' }}>
                {formatToUserTimeZone(request.created_at)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Stack>
  );
}
